import styled from "styled-components";

export const PageHeader = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 18px 18px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
`;

export const HeaderIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 12px;
  background: rgba(0, 123, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;

  i {
    font-size: 22px;
    color: #007bff;
  }
`;

export const HeaderTitle = styled.h3`
  margin: 0;
  color: #212529;
  font-weight: 800;
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: #6c757d;
`;

export const FilterCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 14px;
`;

export const FilterLabel = styled.div`
  font-weight: 800;
  color: #212529;
  margin-bottom: 10px;
`;

export const CounterCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 14px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const CounterNumber = styled.div`
  font-size: 46px;
  font-weight: 900;
  line-height: 1;
  color: #007bff;
`;

export const CounterLabel = styled.small`
  color: #6c757d;
  font-weight: 800;
`;

export const LoadingBox = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 18px;
`;

export const EmptyState = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 18px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  font-size: 52px;
  color: #adb5bd;
  margin-bottom: 14px;
`;

export const EmptyTitle = styled.h5`
  color: #6c757d;
  font-weight: 800;
  margin-bottom: 10px;
`;

export const EmptyText = styled.p`
  color: #6c757d;
  margin: 0;
`;

export const CardShell = styled.div`
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const CardTop = styled.div`
  padding: 14px 14px 10px;
`;

export const CardTitle = styled.div`
  font-weight: 900;
  color: #212529;
  margin-bottom: 10px;
  line-height: 1.2;

  /* evita quebrar layout com temas muito longos */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BadgePill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);

  &[data-variant="success"] {
    background: rgba(40, 167, 69, 0.12);
    color: #1f7a34;
  }

  &[data-variant="info"] {
    background: rgba(23, 162, 184, 0.12);
    color: #117a8b;
  }

  &[data-variant="warning"] {
    background: rgba(255, 193, 7, 0.16);
    color: #9a7400;
  }

  &[data-variant="secondary"] {
    background: rgba(108, 117, 125, 0.12);
    color: #495057;
  }
`;

export const CardBody = styled.div`
  padding: 0 14px 14px;
  flex: 1;
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const MetaItem = styled.div`
  background: rgba(0, 0, 0, 0.025);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 10px 12px;
`;

export const MetaLabel = styled.div`
  font-size: 12px;
  color: #6c757d;
  font-weight: 800;
  margin-bottom: 4px;
`;

export const MetaValue = styled.div`
  color: #212529;
  font-weight: 700;

  &[data-strong] {
    font-weight: 900;
    font-size: 18px;
  }
`;

export const CardFooter = styled.div`
  padding: 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;

export const ActionLink = styled.a`
  width: 100%;
  height: 42px;
  border-radius: 12px;
  font-weight: 900;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  cursor: pointer;

  &[data-variant="success"] {
    background: #28a745;
    color: #ffffff;
  }

  &[data-variant="info"] {
    background: #17a2b8;
    color: #ffffff;
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 12px;
  font-weight: 900;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &[data-variant="primary"] {
    background: #007bff;
    color: #ffffff;
  }

  &[data-variant="danger"] {
    background: #dc3545;
    color: #ffffff;
  }

  &[data-variant="muted"] {
    background: #6c757d;
    color: #ffffff;
    opacity: 0.72;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;